<template>

  <div></div>

</template>

<script>

export default {

  name: 'form-validation',

  mixins: [],

  components: {},

  data() {

    return {}

  },

  computed: {},

  props: {},

  methods: {

    form__validEmail: function(value) {
      let regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

      return regex.test(value);
    },

  },

}

</script>
